"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotBatteryCharging = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotBatteryCharging = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Spot=on,_Size=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M5.63 19.97c-.703 3.753 1.03 7.862 3.181 11.067 2.17 3.193 4.768 5.5 7.584 6.385 2.844.892 5.883.402 9.748.408 3.848.017 8.516.56 11.183-1.429 2.66-1.96 3.32-6.452 2.544-10.368-.765-3.898-2.977-7.238-5.808-8.855-2.82-1.6-6.289-1.483-9.97-2.494-3.7-1-7.63-3.117-11.142-2.48-3.523.62-6.634 4.024-7.32 7.766Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M38 23v-6M9.667 30H6.333A3.333 3.333 0 0 1 3 26.667V13.333A3.333 3.333 0 0 1 6.333 10h5.317m14.683 0h3.334A3.333 3.333 0 0 1 33 13.333v13.334A3.333 3.333 0 0 1 29.667 30H24.35m-4.683-20L13 20h10l-6.667 10"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Spot=on,_Size=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotBatteryCharging = SpotBatteryCharging;
SpotBatteryCharging.displayName = "SpotBatteryCharging";